import React, { useEffect, useState } from 'react';
import DeoLogo from './DeoLogo';

/**
 * Opener — sofistike bakır/kahve. Yeşil/sarı YOK.
 * Faz 0: closed espresso wood doors with central oval keyhole (interior dark espresso)
 * Faz 1: copper key descends, soft warm copper glow inside oval
 * Faz 2: doors slide open revealing dashboard
 */
export default function Opener({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 700);
    const t2 = setTimeout(() => setPhase(2), 2200);
    const t3 = setTimeout(() => onComplete && onComplete(), 3400);
    return () => { [t1, t2, t3].forEach(clearTimeout); };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[100] overflow-hidden" data-testid="opener-sequence"
      style={{
        background: `
          radial-gradient(ellipse 60% 40% at 50% 0%, rgba(224,138,79,0.18), transparent 60%),
          radial-gradient(ellipse 70% 60% at 50% 50%, #4A2F20 0%, #2B1E16 45%, #160C07 100%)
        `,
      }}
    >
      {/* Wood grain stripes */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            repeating-linear-gradient(90deg,
              transparent 0px,
              rgba(70,40,20,0.18) 1px,
              transparent 3px,
              transparent 28px,
              rgba(140,80,40,0.06) 29px,
              transparent 31px,
              transparent 80px,
              rgba(40,20,10,0.22) 81px,
              transparent 84px,
              transparent 140px,
              rgba(180,110,60,0.08) 141px,
              transparent 143px
            )
          `,
          opacity: 0.85,
        }}
      />

      {/* Two doors with central oval keyhole */}
      <div className="absolute inset-0 flex">
        {/* Left door */}
        <div
          className="w-1/2 h-full relative"
          style={{
            background: `
              linear-gradient(90deg, #160C07 0%, #2B1E16 70%, #3A2A1F 100%),
              repeating-linear-gradient(90deg, rgba(0,0,0,0.12) 0px, transparent 2px, transparent 80px)
            `,
            transform: phase >= 2 ? 'translateX(-100%)' : 'translateX(0)',
            transition: 'transform 1.4s cubic-bezier(0.7, 0, 0.3, 1)',
            borderRight: '1px solid rgba(197,108,57,0.35)',
            boxShadow: 'inset -30px 0 80px rgba(0,0,0,0.7)',
          }}
        >
          {/* Wood vertical panels */}
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(90deg, transparent 0px, transparent 119px, rgba(0,0,0,0.3) 120px, transparent 121px)',
          }} />
        </div>

        {/* Right door */}
        <div
          className="w-1/2 h-full relative"
          style={{
            background: `
              linear-gradient(90deg, #3A2A1F 0%, #2B1E16 30%, #160C07 100%),
              repeating-linear-gradient(90deg, rgba(0,0,0,0.12) 0px, transparent 2px, transparent 80px)
            `,
            transform: phase >= 2 ? 'translateX(100%)' : 'translateX(0)',
            transition: 'transform 1.4s cubic-bezier(0.7, 0, 0.3, 1)',
            borderLeft: '1px solid rgba(197,108,57,0.35)',
            boxShadow: 'inset 30px 0 80px rgba(0,0,0,0.7)',
          }}
        >
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(90deg, transparent 0px, transparent 119px, rgba(0,0,0,0.3) 120px, transparent 121px)',
          }} />
        </div>
      </div>

      {/* Central oval keyhole — DARK ESPRESSO interior, copper hairline border */}
      {phase < 2 && (
        <div
          className="absolute left-1/2 top-1/2 pointer-events-none"
          style={{
            transform: 'translate(-50%, -50%)',
            width: '380px',
            height: '600px',
            borderRadius: '190px',
            border: '1px solid rgba(197, 108, 57, 0.55)',
            background: `
              radial-gradient(ellipse at 50% 30%,
                rgba(197, 108, 57, ${phase >= 1 ? 0.18 : 0.06}) 0%,
                rgba(90, 47, 18, ${phase >= 1 ? 0.5 : 0.7}) 40%,
                #0B0703 100%)
            `,
            boxShadow: phase >= 1
              ? 'inset 0 0 60px rgba(0,0,0,0.7), 0 0 30px rgba(197, 108, 57, 0.25)'
              : 'inset 0 0 60px rgba(0,0,0,0.85)',
            transition: 'background 1.2s ease-out, box-shadow 1.2s ease-out',
          }}
        >
          {/* Inner softer oval for depth */}
          <div
            className="absolute"
            style={{
              top: '8px', left: '8px', right: '8px', bottom: '8px',
              borderRadius: '186px',
              border: '1px solid rgba(197, 108, 57, 0.18)',
            }}
          />

          {/* The key + DEO label inside */}
          <div className="absolute inset-0 flex flex-col items-center justify-center pt-6">
            <div
              style={{
                opacity: phase >= 1 ? 1 : 0,
                transform: phase >= 1 ? 'translateY(0) scale(1)' : 'translateY(-20px) scale(0.9)',
                transition: 'all 1s cubic-bezier(0.22, 1, 0.36, 1)',
                filter: phase >= 1 ? 'drop-shadow(0 0 16px rgba(197,108,57,0.5))' : 'none',
              }}
            >
              <DeoLogo size={220} tone="bronze" />
            </div>

            <div
              className="text-center mt-4"
              style={{
                opacity: phase >= 1 ? 1 : 0,
                transition: 'opacity 1s',
                transitionDelay: '0.5s',
              }}
            >
              <div className="font-display copper-shine font-medium tracking-[0.22em]" style={{ fontSize: '14px' }}>
                DİJİTAL EMLAK OFİSİ
              </div>
              <div className="font-display copper-text font-light tracking-[0.18em] mt-2" style={{ fontSize: '13px' }}>
                Emlak Ofisinizin Dijital Zekâsı
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Subtle warm light from keyhole at phase 1 (NO yellow/green burst) */}
      {phase >= 1 && phase < 2 && (
        <div
          className="absolute left-1/2 top-1/2 pointer-events-none"
          style={{
            transform: 'translate(-50%, -50%)',
            width: '600px',
            height: '600px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(224, 138, 79, 0.12) 0%, rgba(197, 108, 57, 0.04) 40%, transparent 70%)',
            opacity: 0.8,
          }}
        />
      )}
    </div>
  );
}
